import { invitationsGateway } from "@/gateways/invitationsGateway";
import type { MutationCallbacks } from "@/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { Invitation } from "./types";

export function useGetInvitations() {
  const query = useQuery({
    queryKey: ["invitations"],
    queryFn: () => invitationsGateway.listInvitations(),
  });

  return {
    ...query,
    getInvitationsStatus: query.status,
    invitations: query.data,
  };
}

export function useCreateInvitation(
  callbacks: MutationCallbacks<Invitation> = {},
) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (invitation: Invitation) =>
      invitationsGateway.createInvitation(invitation),
    onSuccess: (invitation: Invitation) => {
      queryClient.invalidateQueries({ queryKey: ["invitations"] });

      if (callbacks.onSuccess) callbacks.onSuccess(invitation);
    },
  });

  return {
    ...mutation,
    createInvitationStatus: mutation.status,
    createInvitation: mutation.mutate,
  };
}

export function useDeleteInvitation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (invitation: Invitation) =>
      invitationsGateway.deleteInvitation(invitation),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["invitations"] });
    },
  });

  return {
    ...mutation,
    resetDeleteInvitation: mutation.reset,
    deleteInvitationStatus: mutation.status,
    deleteInvitation: mutation.mutate,
  };
}
